<template>

  <div class="group" :ref="refs['TilesGroup']">

    <Tile
      v-for="(tile, index) in builder.currentItem.specs.tiles"
      :index=index
      :tile="tile"
      :key="`${tile.hash}`"
      @tile-remove="tileRemove"
      @tile-update-prop="tileUpdateProp">
    </Tile>

    <div class="button-group" style="margin-top: 20px;">
      <button class="button l_small" @click="tileAdd()">Add tile</button>
      <button class="button l_small l_base" @click="tileSave()">Save tiles</button>
    </div>

  </div>

</template>

<script setup>

var _ = require('lodash');

import { computed, ref, onMounted } from 'vue'

import { useBuilderStore } from "@/stores/builder";
const builder = useBuilderStore();

// init refs
let refHandles = [
  'TilesGroup'
];
const refs = _.chain(refHandles).keyBy().mapValues(ref).value();
refHandles.forEach(item => {
  builder.refs[item] = refs[item];
});

function tileAdd(e) {
  if (_.isUndefined(builder.currentItem.specs.tiles) || !_.isArray(builder.currentItem.specs.tiles) ) builder.currentItem.specs.tiles = [];
  builder.currentItem.specs.tiles.push({
    hash: Math.random().toString(36).substr(2, 9),
    label: ''
  });
  builder.saveCurrentItem();
}

function tileRemove(tileIndex) {
  if (_.isUndefined(builder.currentItem.specs.tiles) || !_.isArray(builder.currentItem.specs.tiles) ) builder.currentItem.specs.tiles = [];
  builder.currentItem.specs.tiles.splice(tileIndex, 1);
}

function tileUpdateProp(index, prop, val) {
  builder.currentItem.specs.tiles[index][prop] = val;
  console.log('updateProp', prop, val);
  builder.saveCurrentItem();
  // if (prop == 'image' || prop == 'size') builder.saveCurrentItem();
}

function tileSave() {
  builder.saveCurrentItem();
}
</script>
